<template lang="html">
  <div class="tile-navigation-wrapper">
      <div class="tile">
        <div class="tile-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 162 140"><path fill="#1d2d19" d="M76.9 0h7.8l2.2.7c-4 .2-8 .2-12 0l2-.7z" opacity=".6"/><g fill="#0b2c00"><path d="M43 19A46.9 46.9 0 0175 .6c3.9.3 8 .3 12 0 8 1.2 15.8 4 22.3 9 9.8 7 16 18 17.9 29.7v10.2a47.1 47.1 0 01-7 17.8c-3 5-8 8.8-11 13.9a31.7 31.7 0 00-5.6 13.8c-.4 3.3-.5 7-3 9.5-3.9 4.2-9.7 5.8-15 6.8h-9.2c-5.6-1-11.6-2.7-15.5-7.2-3.2-3.8-2-9.2-3.5-13.7-2.4-6.9-7-12.7-12-17.9a43.4 43.4 0 01-10.6-22.8V38.5c1.1-7 3.8-13.8 8.2-19.5M75.3 6.5a39.7 39.7 0 00-32.1 23.7 36.7 36.7 0 002.5 33.2c3 5 7.8 8.8 11.1 13.7 3.5 5.1 6.7 10.7 7.2 17 .3 1.9 0 4 1 5.9 1.9 2.6 5 3.7 8 4.6a26 26 0 0022.5-3.2c3.2-2.4 1.8-6.9 2.8-10.3 2-8.3 7.2-15.6 13-21.7a36.8 36.8 0 0010-29.3 36 36 0 00-11-22.3 42.9 42.9 0 00-35-11.3z"/><path d="M72 51.8h17.2c-4.1 3.4-7.2 8.6-6.5 14.1.6 7.9 6.3 13.7 9.8 20.3H69c3.6-6.8 9.7-13 9.8-21.2.4-5.3-2.7-10-6.6-13.2zM58.8 120.6l3.5-.1v7.2h8v-7.2h3.3v18.4h-3.3v-8h-8v8h-3.4v-18.3zM2 120.7h9.3c3.2 1.5 4.3 6 2 8.7-2 2.3-5.4 1.7-8 2l-.1 7.3-3.5.4c.5-6 .2-12.2.3-18.4m3.2 2.8v4.9c1.8-.3 3.6-.3 5.4-.9.4-1.1.4-2.2 0-3.3-1.8-.6-3.6-.6-5.4-.8zM17.6 138.8c2.8-6 5-12.3 8.3-18l2.3-.7c2.8 6.2 5.5 12.4 8.1 18.7h-3.9l-1.6-4.2h-7.7l-1.6 4.2h-3.9m6.8-7.3h5l-2.4-6-2.6 6zM38.7 120.6c5.1.5 10.2.5 15.3 0l-.5 3.2H48v15h-3.4v-15h-5.4l-.6-3.2zM78.4 120.5H82c1 4.2 2.2 8.4 3.3 12.5 1.4-4 2.4-8.2 4-12.1a6 6 0 003.3 0c1.4 4 2.3 7.9 3.8 11.7 1.3-4 2-8.1 3.8-11.9l2.6.3c-.9 6-3.2 11.8-4.8 17.8l-3.2.1c-1.3-4.2-2.5-8.5-4-12.6l-3.7 12.5-3.3.1-5.4-18.4zM105.7 138.8c2.8-6 5-12.3 8.2-18l2.4-.8c2.8 6.3 5.5 12.5 8 18.8h-3.8l-1.6-4.2H111l-1.4 4.2h-4m6.8-7.3h5.1l-2.6-6-2.5 6zM127 121c1.1.2 2.3.2 3.5 0 1.6 2 3 4.4 4.4 6.7l4.6-6.8c1.2.3 2.3.3 3.5 0-1.6 3.7-4.4 6.7-6.2 10.3-.4 2.5-.2 5-.2 7.7h-3.3c0-2.6.1-5.2-.3-7.7-1.7-3.6-4.5-6.5-6-10.3zM146.4 120.6c4.5.4 9 .3 13.5.3l.3 3.1c-3.4 3.7-6.1 7.8-9.2 11.6 3 0 6.1 0 9.2.4l-.1 2.6c-4.5.5-9 .2-13.6.3l-.1-3c3.2-4 6.3-8 9.4-12.2h-9l-.4-3.1z"/></g><path fill="#f39f24" d="M81.1 28.6c-5.5-1.5-4.5-9.9-.2-12.4 3.6 3 4.8 9.8.2 12.4z"/><g fill="#f7d126"><path d="M72 32.8c-5.3-.6-7.3-7.4-4.4-11.5 4.9 1.4 7.4 7.3 4.5 11.5zM89.8 33c-3.7-4-.8-10.8 4.4-11.6 2.2 4.3.6 10.3-4.4 11.6z"/></g><g fill="#00d5d5"><path d="M55 28.3c4.9-2 10.8 2.9 9.6 8.1-4.9 1.5-10.6-3-9.6-8zM97.2 36.2c-2-5.3 4.8-9.5 9.4-8 .6 4.8-4.4 10-9.4 8z"/></g><path fill="#d96d00" d="M81 44.6c-5.4-2-4.4-9.9 0-12.5 3.6 3 4.7 9.9 0 12.5z"/><g fill="#008c8c"><path d="M48.3 40c2.4-1.3 5.3-2.4 8-1.3 2.2.6 3.3 2.8 4.5 4.5-3.9 4-10.9 2-12.5-3.2zM101 43.1c1.3-5.4 8.4-6 12.2-3-1.8 4.6-8.8 7.6-12.1 3z"/></g><path fill="#2c322b" d="M34.8 49.7c-1-3.7-1-7.5 0-11.2v11.2z" opacity=".3"/><g fill="#d9a300"><path d="M64.3 40.5a8.2 8.2 0 0111.4 6c-4.6 3.4-10.8-.8-11.4-6zM86 46.9c.1-5.5 6.4-8.5 11.2-6.4-.7 5.1-6.4 9-11.2 6.4z"/></g><path fill="#262926" d="M127.2 39.3c1 3.4.9 6.9 0 10.2V39.3z" opacity=".2"/><g fill="#98cb00"><path d="M52.9 52.9c2.8-4.6 10.2-5 12.8 0-3 4.5-9.6 4-12.9 0zM95.8 52.5c3-4.5 10-4.1 12.8.3-2 2-4.6 3.9-7.7 3.3-2.4 0-3.8-2-5.1-3.6z"/></g><g fill="#698c00"><path d="M87.4 60c4.4-3.5 10.6-.6 12.4 4.3-4.4 3-11 1-12.4-4.4zM61.8 64.5c1.3-5.1 7.8-8 12.2-4.6-1.4 5.3-7.7 7.1-12.2 4.6z"/></g><path fill="#23311f" d="M76.4 111.3h9.1c-3 .7-6 .7-9.1 0z" opacity=".5"/><path fill="#242923" d="M1.4 121c2.5-2.3 6.8-.8 9.9-.3H2c0 6.2.2 12.3-.3 18.4-1-6-.8-12-.3-18z" opacity=".3"/><path fill="#232f20" d="M38.7 120.6c5-1 10.3-1 15.3 0-5 .5-10.2.5-15.3 0z" opacity=".5"/><path fill="#212b1d" d="M89.2 120.9c-.1-1.8 3.7-1.6 3.4 0a6 6 0 01-3.4 0z" opacity=".4"/><path fill="#243021" d="M100.2 120.7c-.2-1.6 3.1-1.3 2.6.3l-2.6-.3z" opacity=".5"/><path fill="#222d1e" d="M127 121c0-1.7 3.7-1.8 3.5 0-1.2.2-2.4.2-3.6 0z" opacity=".5"/><path fill="#222c1e" d="M139.5 121c-.3-1.8 3.6-1.7 3.5 0-1.2.2-2.3.2-3.5 0z" opacity=".5"/><path fill="#263023" d="M146.4 120.6c4.5-1 9.1-.8 13.7-.4 1.3 1 .6 2.6 0 3.8l-.2-3.1c-4.5 0-9 0-13.5-.3z" opacity=".4"/><path fill="#383f37" d="M160.2 136c1.6-.3 1.5 3.1-.1 2.6V136z" opacity=".4"/></svg>
        </div>
      </div>
      <div class="tile" @click="navigateAbout">
          <label>About</label>
      </div>
      <div class="tile">
          <label>Search</label>
      </div>
      <div class="tile" @click="navigateBrowse">
          <label>Browse</label>
      </div>
      <div class="tile" @click="navigateFlashcards">
          <label>Flashcards</label>
      </div>
      <div class="tile">
          <label>Quiz</label>
      </div>
      <div class="tile">
          <label>Account</label>
      </div>
      <div class="tile" @click="navigateDonate">
          <label>Donate</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHome',
  methods: {
    navigateBrowse () {
      this.$router.push({ name: 'PageLearn', params: {} })
    },
    navigateFlashcards () {
      this.$router.push({ name: 'PageFlashcardSelect', params: {} })
    },
    navigateAbout () {
      this.$router.push({ name: 'PageAbout', params: {} })
    },
    navigateDonate () {
      this.$router.push({ name: 'PageDonate', params: {} })
    }
  }
}
</script>

<style lang="css" scoped>
.tile-navigation-wrapper {
  display:grid;
  grid-template-columns: 1fr 1fr;
  height:100%;
  grid-auto-rows:1fr;
}
.tile {
  flex: 1 0 0px;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:10px;
  font-size:5vmin;
  color:rgba(255,255,255,0.85);
  font-family: 'Cabin', sans-serif;
  text-transform:uppercase;
  /* aspect-ratio: 1/1; */
}
.tile-content label {
  margin-bottom:0px;
}
.tile:nth-child(1) {background-color: #e8f0e3}
.tile:nth-child(2) {background-color: #f39f24}
.tile:nth-child(3) {background-color: hsl(0, 50%, 37%)}
.tile:nth-child(4) {background-color: hsl(177, 89%, 25%)}
.tile:nth-child(5) {background-color: #98cb00}
.tile:nth-child(6) {background-color: hsl(133, 94%, 21%)}
.tile:nth-child(7) {background-color: hsl(29, 100%, 28%)}
.tile:nth-child(8) {background-color: hsl(268, 86%, 26%)}


@media(orientation:landscape){
  
  .tile-navigation-wrapper {
    grid-template-columns:1fr 1fr 1fr 1fr;
  }
}

</style>
